<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm10 md8>
            <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Changement de mot de passe</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-form autocomplete="off" @submit.prevent="changePassword">
                <v-card-text>
                    <v-alert v-model="has_success" dismissible type="warning">{{ success_message }}</v-alert>
                    <v-alert v-model="has_error" dismissible type="error">{{ error_message }}</v-alert>
                        <v-text-field id="password" prepend-icon="lock" name="password" label="Mot de passe" type="password" v-model="password" required></v-text-field>
                        <v-text-field id="password_confirmation" prepend-icon="lock" name="password_confirmation" label="Confirmer votre mot de passe" type="password" v-model="passwordConfirmation" required></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit" v-if="!this.has_success">Changer le mot de passe</v-btn>
                        <v-btn color="secondary" v-else @click.prevent="showLoginForm">Retour</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        name: 'ForgotPassword',
        data() {
            return {
                token: null,
                email: null,
                password: null,
                passwordConfirmation: null,
                has_error: false,
                has_success: false,
                success_message: String,
                error_message: String
            }
        },

        mounted() {
            this.token = this.$route.params.token
            this.email = this.$route.query.email
        },

        methods: {
            ...mapActions(["resetPassword"]),
            changePassword() {
                this.resetPassword({
                       email: this.email,
                       token: this.token,
                       password: this.password,
                       password_confirmation: this.passwordConfirmation,
                    }).then(response => {
                        this.has_error = false
                        this.error_message = null
                        this.has_success = true
                        this.success_message = "Mot de passe modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe."
                    }).catch(error => {
                        this.has_success = false
                        this.has_error = true
                        this.success_message = null
                        this.error_message = error.response.data.message
                    })
            },
            showLoginForm() {
                this.$router.push({name: 'login'})
            }
        }
    }
</script>

<style scoped>

</style>
